/**
 * axios封装
 * 请求拦截、响应拦截、错误统一处理
 */
import axios from 'axios';
import qs from 'qs';
import api from '@/config/api.js'

const errorHandle = status => {
  // HTTP状态码判断
  if (status >= 500) {
    tip('系统开小差了, 请稍后重试');
  } else {
    tip('网络请求失败, 请刷新重试');
  }
};

// 创建axios实例
const axiosInstance = axios.create({
  baseURL: api.topURL,
  timeout: 1000 * 20,

  transformRequest: [
    function (data) {
      return qs.stringify(data);
    }
  ]
});

/**
 * 请求拦截器
 */
axiosInstance.interceptors.request.use(
  config => {
    if (config.isUser) {
      config.baseURL = process.env.VUE_APP_PERMISSION_URL;
    }

    return config;
  },
  error => Promise.reject(error)
);

/**
 * 响应拦截器
 */
axiosInstance.interceptors.response.use(
  res => {
    if (res.status === 200) {
      const statusCode = res.data.rcode;
      if (statusCode === '000000') {
        return Promise.resolve(res.data || res.rdata);
      }
      if (statusCode === '800001') {
        window.location.href = process.env.VUE_APP_LOGN_HOST;
        return;
      }
    }
    return Promise.reject(res.data.rdesc);
  },
  error => {
    if (error) {
      if (error.response) {
        // 请求已发出，但是不在2xx的范围
        errorHandle(error.response.status);
        return Promise.reject(error.response);
      } else if (error.message === '路由跳转取消请求') {
        return Promise.reject(error.message);
      }
    } else {
      console.log('网络请求失败, 请刷新重试');
      return Promise.reject(error);
    }
  }
);

const ajaxOldGet = (url, data, config) => {
  let _data = { params: data }
  if (config) {
    Object.keys(config).forEach(item => {
      _data[item] = config[item]
    })
  }
  console.log('-----_data', _data)
  axiosInstance.get(url, _data, config);
}
const ajaxOldPost = (url, data, config) => axiosInstance.post(url, data, config);

export { ajaxOldGet, ajaxOldPost };

export default axiosInstance;



// WEBPACK FOOTER //
// ./src/plugin/upload/oldHttp.js